import React from 'react';

const ApplicationSuccess = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div 
        className="bg-white rounded-[24px] border-t-[0.3px] w-[358px] h-[518px] shadow-lg"
        style={{
          paddingTop: '32px',
          paddingRight: '20px',
          paddingBottom: '32px',
          paddingLeft: '20px',
        }}
      >
        <div className="flex flex-col items-center gap-[30px]">
          <h2 className="font-[LTWave] font-bold text-[24px] leading-[150%] tracking-[-2%] text-center capitalize">
            🎉 Application Submitted Successfully!
          </h2>
          
          <div className="w-[318px] h-[349px] border border-gray-200 rounded-[16px] flex flex-col items-center justify-between p-6 bg-white shadow-sm">
            <div className="text-center">
              <h3 className="font-inter font-bold text-[16px] leading-[150%] mb-4">
                Thank You for Applying!
              </h3>
              
              <p className="font-inter font-normal text-[16px] text-[#6C6C6C] leading-[150%] text-center">
                Our team will review your details shortly. If your profile aligns with our requirements, we'll get in touch with you soon.
              </p>
            </div>
            
            <div className="w-full space-y-4">
              <button 
                className="w-[282px] h-[56px] rounded-[9px] font-inter font-medium text-[16px] text-white bg-gradient-to-r from-[#5b2c2a] via-[#b03a2e] to-[#f39c12]"                
                onClick={() => onClose('explore')}
              >
                Explore More Jobs
              </button>
              
              <div className="w-[282px] h-[65px] rounded-[9px] border border-[#E9E9E9] bg-[#F9F9FB] flex flex-col items-center justify-center p-2">
                <div className="flex items-center gap-1">
                  <span className="font-inter font-regular text-[16px] text-gray-700">
                    Need to reach us?
                  </span>
                </div>
                <div className="flex items-center gap-1 mt-1">
                  <span className="text-[16px]">📧</span>
                  <span className="font-inter font-regular text-[16px]">
                    career@agastyaagro.com
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApplicationSuccess;
